import { devLog } from '../utils';
import { REGISTER_FEED_ENTRY_UI_CHANGE } from './feed-actions';

export function reducer(state, action) {
  devLog(`[feed-reducer] action ${action.type}`);
  switch (action.type) {
    case REGISTER_FEED_ENTRY_UI_CHANGE: {
      return {
        count: state.count + 1
      };
    }
    default:
      throw new Error(`${action.type} - not recognized`);
  }
}

export default { reducer };
